// import MailSidebar from '../MailSidebar';
import MailContain from "./MailContain";
import React, { Fragment } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import MailSidebar from "./MailSidebar";
import { Link, useNavigate } from "react-router-dom";

const ReadMailContain = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`${process.env.PUBLIC_URL}/email/mailbox`);
    // window.location.reload();
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <div className="email-wrap">
          <Row>
            <Col xl="1" md="2" sm="2" className="box-col-3">
              {/* <But
                to={{
                  pathname: `${process.env.PUBLIC_URL}/email/mailbox`,
                }}
              > */}
                <Button className="btn btn-primary" onClick={handleBack}>
                  <i className="fa fa-arrow-left"></i>
                </Button>
              {/* </But> */}
            </Col>
            <Col xl="11" md="10" sm="10" className="box-col-9">
              <MailContain />
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default ReadMailContain;
